import React from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { isStatusTrue } from "../utils/patientUtils";

interface MedicalConditionCardProps {
  label: string;
  condition: { status?: string | boolean; note?: string };
  theme?: "light" | "dark";
}

const MedicalConditionCard: React.FC<MedicalConditionCardProps> = ({
  label,
  condition,
  theme = "light",
}) => {
  const isActive = isStatusTrue(condition?.status);
  const noteText = condition?.note != null ? String(condition.note).trim() : "";

  return (
    <div className={`rounded-lg p-3 ${
      isActive
        ? theme === "dark"
          ? "bg-red-900/30 border border-red-800"
          : "bg-red-50 border border-red-100"
        : theme === "dark"
        ? "bg-slate-700/50"
        : "bg-slate-50"
    }`}>
      <div className="flex items-center justify-between">
        <p className={`text-sm font-medium ${
          theme === "dark" ? "text-slate-300" : "text-slate-700"
        }`}>{label}</p>
        {isActive ? (
          <CheckCircleIcon className={theme === "dark" ? "text-red-400" : "text-red-500"} sx={{ fontSize: 18 }} />
        ) : (
          <CancelIcon className={theme === "dark" ? "text-slate-500" : "text-slate-300"} sx={{ fontSize: 18 }} />
        )}
      </div>
      {isActive && noteText && (
        <p className={`text-xs mt-1 ${
          theme === "dark" ? "text-red-300" : "text-red-600"
        }`}>Note: {noteText}</p>
      )}
    </div>
  );
};

export default MedicalConditionCard;

